import React, { useState } from 'react';
import { Outlet, Link } from 'react-router-dom';
import { Menu, X, Phone, Mail, MapPin, Clock } from 'lucide-react';
import SEOHead from './SEOHead';

const Layout = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      <SEOHead />
      <nav className="bg-black/95 backdrop-blur-md border-b border-gold/20 sticky top-0 z-50">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-4">
            <Link to="/" className="flex items-center">
              <h1 className="text-2xl font-bold gold-gradient">Echt Gold</h1>
            </Link>
            
            <div className="hidden lg:flex items-center gap-8">
              <Link to="/" className="text-gray-300 hover:text-gold transition-colors">Startseite</Link>
              <div className="relative group">
                <button className="text-gray-300 hover:text-gold transition-colors">Leistungen</button>
                <div className="absolute top-full left-0 mt-2 w-56 bg-black/95 border border-gold/20 rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300">
                  <Link to="/goldankauf" className="block px-4 py-3 hover:bg-gold/10 transition-colors">Goldankauf</Link>
                  <Link to="/silberankauf" className="block px-4 py-3 hover:bg-gold/10 transition-colors">Silberankauf</Link>
                  <Link to="/uhrenankauf" className="block px-4 py-3 hover:bg-gold/10 transition-colors">Uhrenankauf</Link>
                  <Link to="/schmuckankauf" className="block px-4 py-3 hover:bg-gold/10 transition-colors">Schmuckankauf</Link>
                  <Link to="/diamantenankauf" className="block px-4 py-3 hover:bg-gold/10 transition-colors">Diamantenankauf</Link>
                </div>
              </div>
              <Link to="/faq" className="text-gray-300 hover:text-gold transition-colors">FAQ</Link>
              <Link to="/magazin" className="text-gray-300 hover:text-gold transition-colors">Magazin</Link>
              <Link to="/bewertungen" className="text-gray-300 hover:text-gold transition-colors">Bewertungen</Link>
              <Link to="/kontakt" className="btn-primary" style={{padding: '0.625rem 1.5rem', fontSize: '0.95rem'}}>Kontakt</Link>
            </div>

            <button 
              className="lg:hidden text-gold"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-toggle"
              aria-label={mobileMenuOpen ? "Menü schließen" : "Menü öffnen"}
              aria-expanded={mobileMenuOpen}
            >
              {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>

          {mobileMenuOpen && (
            <div className="lg:hidden py-4 border-t border-gold/20" data-testid="mobile-menu">
              <Link to="/" className="block py-2 text-gray-300 hover:text-gold transition-colors">Startseite</Link>
              <Link to="/goldankauf" className="block py-2 text-gray-300 hover:text-gold transition-colors">Goldankauf</Link>
              <Link to="/silberankauf" className="block py-2 text-gray-300 hover:text-gold transition-colors">Silberankauf</Link>
              <Link to="/uhrenankauf" className="block py-2 text-gray-300 hover:text-gold transition-colors">Uhrenankauf</Link>
              <Link to="/schmuckankauf" className="block py-2 text-gray-300 hover:text-gold transition-colors">Schmuckankauf</Link>
              <Link to="/diamantenankauf" className="block py-2 text-gray-300 hover:text-gold transition-colors">Diamantenankauf</Link>
              <Link to="/faq" className="block py-2 text-gray-300 hover:text-gold transition-colors">FAQ</Link>
              <Link to="/magazin" className="block py-2 text-gray-300 hover:text-gold transition-colors">Magazin</Link>
              <Link to="/bewertungen" className="block py-2 text-gray-300 hover:text-gold transition-colors">Bewertungen</Link>
              <Link to="/kontakt" className="block py-2 text-gold font-semibold">Kontakt</Link>
            </div>
          )}
        </div>
      </nav>

      <main>
        <Outlet />
      </main>

      <footer className="bg-black border-t border-gold/20 py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold gold-text mb-4">Echt Gold</h3>
              <p className="text-gray-400 mb-4">Ihr vertrauensvoller Partner für den Ankauf von Edelmetallen, Schmuck und Luxusuhren in NRW.</p>
              <div className="flex gap-3">
                <a href="tel:023139085116" className="w-10 h-10 bg-gold/10 border border-gold/30 rounded-full flex items-center justify-center hover:bg-gold/20 transition-colors">
                  <Phone size={18} className="text-gold" />
                </a>
                <a href="mailto:Info@echtgold.de" className="w-10 h-10 bg-gold/10 border border-gold/30 rounded-full flex items-center justify-center hover:bg-gold/20 transition-colors">
                  <Mail size={18} className="text-gold" />
                </a>
              </div>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold gold-text mb-4">Leistungen</h4>
              <ul className="space-y-2">
                <li><Link to="/goldankauf" className="text-gray-400 hover:text-gold transition-colors">Goldankauf</Link></li>
                <li><Link to="/silberankauf" className="text-gray-400 hover:text-gold transition-colors">Silberankauf</Link></li>
                <li><Link to="/uhrenankauf" className="text-gray-400 hover:text-gold transition-colors">Uhrenankauf</Link></li>
                <li><Link to="/schmuckankauf" className="text-gray-400 hover:text-gold transition-colors">Schmuckankauf</Link></li>
                <li><Link to="/diamantenankauf" className="text-gray-400 hover:text-gold transition-colors">Diamantenankauf</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold gold-text mb-4">Informationen</h4>
              <ul className="space-y-2">
                <li><Link to="/faq" className="text-gray-400 hover:text-gold transition-colors">FAQ</Link></li>
                <li><Link to="/magazin" className="text-gray-400 hover:text-gold transition-colors">Magazin</Link></li>
                <li><Link to="/bewertungen" className="text-gray-400 hover:text-gold transition-colors">Bewertungen</Link></li>
                <li><Link to="/standort" className="text-gray-400 hover:text-gold transition-colors">Standort</Link></li>
                <li><Link to="/impressum" className="text-gray-400 hover:text-gold transition-colors">Impressum</Link></li>
                <li><Link to="/datenschutz" className="text-gray-400 hover:text-gold transition-colors">Datenschutz</Link></li>
                <li><Link to="/agb" className="text-gray-400 hover:text-gold transition-colors">AGB</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold gold-text mb-4">Kontakt</h4>
              <ul className="space-y-3 text-gray-400">
                <li className="flex items-start gap-2">
                  <MapPin size={18} className="text-gold mt-1 flex-shrink-0" />
                  <span>Neben dem Brand 10<br />44135 Dortmund</span>
                </li>
                <li className="flex items-center gap-2">
                  <Phone size={18} className="text-gold flex-shrink-0" />
                  <a href="tel:023139085116" className="hover:text-gold transition-colors">0231 39085116</a>
                </li>
                <li className="flex items-center gap-2">
                  <Mail size={18} className="text-gold flex-shrink-0" />
                  <a href="mailto:Info@echtgold.de" className="hover:text-gold transition-colors">Info@echtgold.de</a>
                </li>
                <li className="flex items-start gap-2">
                  <Clock size={18} className="text-gold mt-1 flex-shrink-0" />
                  <span>Mo-Fr: 08:00-18:00<br />Sa: 09:00-17:00</span>
                </li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gold/20 mt-8 pt-8 text-center text-gray-500">
            <p>&copy; {new Date().getFullYear()} Echt Gold. Alle Rechte vorbehalten.</p>
          </div>
        </div>
      </footer>

      <a 
        href="tel:023139085116" 
        className="phone-float"
        data-testid="phone-button"
        aria-label="Jetzt anrufen"
      >
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
        </svg>
      </a>

      <a 
        href="https://wa.me/4923139085116" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="whatsapp-float"
        data-testid="whatsapp-button"
        aria-label="WhatsApp Kontakt"
      >
        <svg width="32" height="32" viewBox="0 0 32 32" fill="white">
          <path d="M16 0C7.164 0 0 7.164 0 16c0 2.826.739 5.482 2.031 7.776L0 32l8.426-2.019A15.911 15.911 0 0016 32c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.333c-2.552 0-4.96-.715-7.003-1.952l-.503-.297-5.213 1.252 1.27-5.106-.326-.52A13.265 13.265 0 012.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.317-9.984c-.4-.2-2.368-1.168-2.735-1.301-.367-.134-.634-.2-.901.2-.267.4-1.034 1.301-1.268 1.568-.234.267-.468.3-.868.1-.4-.2-1.688-.622-3.215-1.983-1.188-1.06-1.99-2.368-2.224-2.768-.234-.4-.025-.616.176-.816.18-.18.4-.468.6-.702.2-.234.267-.4.4-.668.134-.267.067-.5-.033-.702-.1-.2-.901-2.168-1.235-2.968-.325-.778-.655-.672-.901-.685-.234-.013-.5-.017-.768-.017-.267 0-.702.1-1.068.5-.367.4-1.401 1.368-1.401 3.335s1.435 3.868 1.635 4.135c.2.267 2.826 4.315 6.847 6.052.957.413 1.704.66 2.286.844.96.305 1.835.262 2.526.159.771-.115 2.368-.968 2.702-1.903.334-.935.334-1.736.234-1.903-.1-.168-.368-.268-.768-.468z"/>
        </svg>
      </a>
    </>
  );
};

export default Layout;